import $ from 'jquery';
import 'slick-carousel';
import SlickPlayPauseControls from './Slick.PlayPauseControls';

const defaults = {
  speed: 500,
  autoplay: true,
  autoplaySpeed: 5000,
  dots: true,
  arrows: false,
  infinite: true,
  pauseOnFocus: false,
  waitForAnimate: false,
  fade: true,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        autoplay: false,
      },
    },
  ],
};

/**
 * Gallery Constructor
 */
function Hero(element, options) {
  this.element = element;
  this.$element = $(element);
  this.settings = $.extend(true, defaults, options);

  // add slick carousel functionality
  this.$slickContainer = this.addSlick();

  // add play/pause functionality
  this.controls = this.addControls();

  // set component ready
  this.ready();
}

Hero.prototype = {
  addSlick() {
    const $slider = this.$element.find('.block-content');
    return $slider.slick(this.settings);
  },
  addControls() {
    return new SlickPlayPauseControls(this.$slickContainer, {
      attachTo: this.$slickContainer,
    });
  },
  ready() {
    this.$element.closest('.page-top').addClass('ready');
  },
};

export default Hero;
